module.exports = __webpack_public_path__ + "img/cartao_mastercard.a622a72a.png";